"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var fails = require("../internals/fails");
var arraySlice = require("../internals/array-slice");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var FORCED = fails(function() {
  new Int8Array(1).slice();
});
exportTypedArrayMethod("slice", function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = getTypedArrayConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);
